var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachemnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94021 14.51C7.32021 14.28 6.77021 13.83 6.42021 13.19C5.62021 11.73 6.11021 9.83001 7.53021 8.95001L9.87021 7.5C11.2802 6.62 13.1002 7.09999 13.9002 8.54999C14.7002 10.01 14.2102 11.91 12.7902 12.79L12.4802 13.01",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1102 9.45001C16.7302 9.68001 17.2802 10.13 17.6302 10.77C18.4302 12.23 17.9402 14.13 16.5202 15.01L14.1802 16.46C12.7702 17.34 10.9502 16.86 10.1502 15.41C9.35019 13.95 9.84019 12.05 11.2602 11.17L11.5702 10.95",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachemnt);
export default __webpack_public_path__ + "static/media/attachemnt.850a57e742d42788acd6d8e5666d4562.svg";
export { ForwardRef as ReactComponent };